<template>
  <div>
    <el-row class="pdbot6 borderBot">
      <el-col :span="12">
        <div class="fb f16">推荐服务</div>
      </el-col>
      <el-col :span="12">
        <div class="tr f12" >
          <el-link type="info" @click="tolist(-1)" style="cursor: pointer;">更多></el-link>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4" v-for="item in serviceList" :key="item.id">
        <div class="iconbox" @click="toinfor(item.id)">
          <el-row>
            <el-col :span="8">
              <!-- <svg class="icon svg-icon" aria-hidden="true">
                <use :xlink:href="'#icon-'+item.icon"></use>
              </svg> -->
               <i class="icon iconfont" :class="'icon-'+item.icon" style="font-size:36px;color: #3cba1a;;"></i>
            </el-col>
            <el-col :span="16" class="icontext">{{item.serviceName}}</el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-row class="pdbot6">
      <el-tabs v-model="activeName" @tab-click="getServiceByType">
        <el-tab-pane label="全部事项" name="2">
          <!-- 学生办事 start  -->
          <el-row>
            <!-- for start -->
            <el-col :span="6" v-for="item in serviceListByType" :key="'type'+item.id">
              <div class="iconbox2 tc" @click="toinfor(item.id)">
                <!-- <svg class="icon svg-icon" aria-hidden="true">
                  <use :xlink:href="'#icon-'+item.icon"></use>
                </svg> -->
                <i class="icon iconfont" :class="'icon-'+item.icon" style="font-size:36px;color: #3cba1a;"></i>
                <p class="fb">{{item.serviceName}}</p>
                <!-- title的内容为鼠标停留提示内容 -->
                <!-- <p class="moduletitle" style="color:#737373" :title="item.serviceText">
                  {{item.serviceText}}
                </p> -->
              </div>
            </el-col>
            <!-- for end -->
            <el-col :span="6">
              <div class="iconbox2 tc" @click="tolist(0)">
                <i class="el-icon-search" style="font-size: 40px;color:#3cba1a"></i>
                <p class="fb">查看全部</p>
              </div>
            </el-col>
          </el-row>
          <!-- 学生办事 end -->
        </el-tab-pane>
        <el-tab-pane label="学生办事" name="0">
          <!-- 学生办事 start  -->
          <el-row>
            <!-- for start -->
            <el-col :span="6" v-for="item in serviceListByType" :key="'type'+item.id">
              <div class="iconbox2 tc" @click="toinfor(item.id)">
                <!-- <svg class="icon svg-icon" aria-hidden="true">
                  <use :xlink:href="'#icon-'+item.icon"></use>
                </svg> -->
                <i class="icon iconfont" :class="'icon-'+item.icon" style="font-size:36px;color: #3cba1a;"></i>
                <p class="fb">{{item.serviceName}}</p>
                <!-- title的内容为鼠标停留提示内容 -->
                <!-- <p class="moduletitle" style="color:#737373" :title="item.serviceText">
                  {{item.serviceText}}
                </p> -->
              </div>
            </el-col>
            <!-- for end -->
            <el-col :span="6">
              <div class="iconbox2 tc" @click="tolist(0)">
                <i class="el-icon-search" style="font-size: 40px;color:#3cba1a"></i>
                <p class="fb">查看全部</p>
              </div>
            </el-col>
          </el-row>
          <!-- 学生办事 end -->
        </el-tab-pane>
        <el-tab-pane label="教师办事" name="1">
          <el-row>
            <el-col :span="6" v-for="item in serviceListByType" :key="'type'+item.id">
              <div class="iconbox2 tc" @click="toinfor(item.id)">
                <!-- <svg class="icon svg-icon" aria-hidden="true">
                  <use :xlink:href="'#icon-'+item.icon"></use>
                </svg> -->
                  <i class="icon iconfont" :class="'icon-'+item.icon" style="font-size:36px;color: #3cba1a;"></i>
                <p class="fb">{{item.serviceName}}</p>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="iconbox2 tc" @click="tolist(1)">
                <i class="el-icon-search" style="font-size: 40px;color: #3cba1a"></i>
                <p class="fb">查看全部</p>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="访客办事" name="3">
          <el-row>
            <el-col :span="6" v-for="item in serviceListByType" :key="'type'+item.id">
              <div class="iconbox2 tc" @click="toinfor(item.id)">
                <!-- <svg class="icon svg-icon" aria-hidden="true">
                  <use :xlink:href="'#icon-'+item.icon"></use>
                </svg> -->
                  <i class="icon iconfont" :class="'icon-'+item.icon" style="font-size:36px;color: #3cba1a;"></i>
                <p class="fb">{{item.serviceName}}</p>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="iconbox2 tc" @click="tolist(3)">
                <i class="el-icon-search" style="font-size: 40px;color: #3cba1a"></i>
                <p class="fb">查看全部</p>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <iframe :src="casUrl" v-if="casShow"></iframe>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import "../static/css/my.css";
import { mapGetters } from 'vuex'
import { queryService } from '@/api/serviceHome'
import { queryUserInfoByUserid } from '@/api/myHome'
import { ipURL, baseURL } from "@/config/net.config.js";

export default {
  name: "serviceHome",
  data() {
    return {
      url: "",
      activeName: "2",
      serviceList: [],
      serviceListByType: [],
      casUrl:ipURL +'/cas/login?service='+baseURL+'/index',
      casShow:false,
    };
  },
  created(){
    // if (!sessionStorage.getItem('userId')) {
    //   console.log('11111111111111111111',sessionStorage.getItem('token'));
    //   // this.casShow=true     
    //   window.location.href=ipURL +'/cas/login?service='+baseURL+'/index'
    // }
  },
  mounted() {
    console.log('22222222222222222',sessionStorage.getItem('token'));
    // if (!sessionStorage.getItem('token')) {
    //   console.log('11111111111111111111',sessionStorage.getItem('token'));
    //   // this.casShow=true     
    //   window.location.href=ipURL +'/cas/login?service='+baseURL+'/index'
    // }
    // this.casShow=false 
    // window.location.href=ipURL +'/cas/login?service='+baseURL+'/index'
    // cas?.close()
    this.getService()
    this.getServiceByType()
    this.getUserInfoByUserid()
  },
  computed: {
    ...mapGetters(['getUserId'])
  },
  methods: {
    //推荐服务
    async getService() {
      let params = {
        searchData: JSON.stringify([{
        name: 'eq_useState',
        value: 1
      }]),
        pageIndex: 1,
        pageSize: 12,
        sortField: 'useCount',
        sortOrder: 'desc'
      }
      const data = await queryService(params)
      if (data.msgCode == 0) {
        console.log('推荐服务',data.data)
        this.serviceList = data.data
      }
    },
    // 学生/教师/游客 办事
    async getServiceByType() {
      let searchData = [{
        name: 'eq_useState',
        value: 1
      }]
      if(this.activeName!='2'){
        searchData.push({
          name: 'like_f2',
          value: this.activeName,
        })
      }
      let params = {
        searchData: JSON.stringify(searchData),
        pageIndex: 1,
        pageSize: 1000,
        sortField: 'serviceSort',
        sortOrder: 'ASC'
      }
      const data = await queryService(params)
      this.serviceListByType = data.data
    },
    tolist(id) {
      this.$router.push('/serviceList?id=' + id)
    },
    toinfor(id) {
      this.$router.push("/ServiceInfor?id=" + id);
    },
    // 登录了就获取用户信息
    async getUserInfoByUserid() {
      console.log(this.getUserId)
      if (this.getUserId) {
        const data = await queryUserInfoByUserid(this.getUserId)
        console.log(data)
        if (data.msgCode == 0) {
          this.$store.commit('setUserInfo', JSON.stringify(data.data))
        }
      }
    },
  },
  components: {
    // HelloWorld
  },
};
</script>
<style>
.iconbox {
  border: 1px solid #eee;
  border-radius: 5px;
  padding: 15px 6px;
  /*box-shadow:0px 0px 6px 2px rgba(0,0,0,0.1);*/
  margin: 10px;
  cursor: pointer;
  /* background: #f5faf8; */
}

.iconbox:hover {
  background: rgba(194, 230, 211, 0.3);
}

.iconbox2 {
  border: 1px solid #eee;
  border-radius: 5px;
  padding: 15px 10px;
  /*box-shadow:0px 0px 6px 2px rgba(0,0,0,0.1);*/
  margin: 10px;
  background: #f5faf8;
  /* height: 80px; */
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center
}

.icontext {
  height: 40px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
}
.el-tabs__item{font-size: 16px !important;}
.el-tabs__item.is-active {
  color: #2c3e50 !important;
  font-weight: bold;
}

.moduletitle {
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /*控制行数*/
  -webkit-box-orient: vertical;
}

.moduletitle a {
  padding: 0 3px;
}
  .el-tabs__active-bar{background-color: #008A2C !important;}
</style>